import { Outlet } from 'react-router-dom'

import { Box, Button, Card, Link, Text, Title } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import emptyStateTraining1 from './images/emptyStateTraining1.png'
import emptyStateTraining2 from './images/emptyStateTraining2.png'
import emptyStateTraining3 from './images/emptyStateTraining3.png'

type Props = {
  canCreate: boolean
}

const EmptyState: React.FC<Props> = ({ canCreate }) => {
  const { navigation } = useNavigation()

  return (
    <>
      <Box
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s32"
        flexGrow
        padding="s24"
      >
        <Title title={i18n.t('trainings.trainings_revamp.empty_state.title')} />
        <Box width="s600">
          <Text.Normal size="300" color="grey800">
            {i18n.t('trainings.trainings_revamp.empty_state.description')}
          </Text.Normal>
        </Box>
        <Box gap="s24" flexDirection="row">
          {canCreate && (
            <Button.Router
              iconName="add"
              to={navigation.trainings.list.index.new.fullPath()}
              onClick={() =>
                track(trackingEvents.training.trainingCreationWizard.goToNewCourseWizard)
              }
            >
              {i18n.t('trainings.trainings_revamp.empty_state.create_training')}
            </Button.Router>
          )}
        </Box>
        <Box flexDirection="row" gap="s24">
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining1}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.learning_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.learning_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining2}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.monitor_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.monitor_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training_exports')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining3}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.metrics_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.metrics_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training_insights')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
        </Box>
      </Box>
      <Outlet />
    </>
  )
}

export default EmptyState
